'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Typography, Link } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { MuiTextField } from '@/components/textfield/MuiTextField';
import { MuiButton } from '@/components/button/MuiButton';
import { SearchHospitalNameType } from '@/schemas/SearchHospitalNameSchema';

type Props = {
  isPublicSearch: boolean;
};

export function HospitalSearchBox({ isPublicSearch }: Props) {
  const { control, register, watch } = useFormContext<SearchHospitalNameType>();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Link
        href={`/${
          isPublicSearch ? 'public' : 'app'
        }/stations/search?searchTarget=hospital`}
        color="#13131D"
        underline="none"
      >
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            '@media (max-width: 800px)': {
              gap: 1,
            },
          }}
        >
          <NavigateBeforeIcon fontSize="large" />
          <Typography variant="JP/Heading/xl/Bold/Tight">
            医療機関名から検索
          </Typography>
        </Box>
      </Link>

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <MuiTextField
          fullWidth
          name={register('portal_office_name').name}
          control={control}
          placeholder="医療機関名"
          sx={{ backgroundColor: '#FAFAFA' }}
        />
        <MuiTextField
          fullWidth
          name={register('medical_institution_code').name}
          control={control}
          placeholder="医療機関コード"
          sx={{ backgroundColor: '#FAFAFA' }}
        />
        <MuiButton
          type="submit"
          disabled={
            !watch('portal_office_name') && !watch('medical_institution_code')
          }
        >
          検索
        </MuiButton>
      </Box>
    </Box>
  );
}
